/** @module csi/image/ImageEditorController */
define([
	"dojo/_base/declare",
	"dijit/form/Button",
	"csi/_base/storage",
	"csi/action/ActionView",
	"csi/action/NewFileController",
	"csi/def/View",
	"csi/action/ProxyController",
	"csi/html",
	"csi/locale",
	"csi/model/image",
	"csi/reflection",
	"csi/reflectionHints",
	"csi/widget/CheckBox",
	"csi/widget/Tooltip",
	"csi/xml",
	"underscore",
	"./LightBoxEditor"
], function(declare, Button, storage, ActionView, NewFileController, View, ProxyController, html, locale, {ATTR_IMAGES}, reflection, reflectionHints, CheckBox, Tooltip, xml, _, LightBoxEditor) {

	var IMAGE_EDITOR_INFO_STORAGE_KEY = "ImageEditorInfoStorageKey";
	var _SaveReplaceController = declare([ProxyController], {
		getConfirmButton() {
			return "CONFIRM";
		},

		hasToConfirmAction() {
			return true;
		},

		//Adds title name and sets the message to confirm message popup
		confirmAction(params) {
			var node = this.widget.getNode();

			$("body").addClass("csi-show-image-editor-save-replace");
			params.title = node.$Name;

			// message is required
			params.materialIcon = " ";
			params.message = locale.resource("ImageSaveOverwriteMsg");

			this.inherited(arguments);
		},

		/**
		 * Handle multiple popup close and still keep view active
		 */
		postProcess(/*Boolean*/bStatus) {
			this.closeDialog();

			_.delay(function() {
				// wait till dialog closes to remove classsto prevent flickering
				$("body").removeClass(["csi-show-image-editor", "csi-show-image-editor-save-replace"]);
			}, 500);

			if (bStatus) {
				this.resumeProcess();
				return this.inherited(arguments);
			} else {
				this.endProcess();
			}
		}
	});

	return declare(NewFileController, {
		moduleName: "SiteAdmin",
		operationName: "UploadEditedImage",

		/** @property {ImageData} imageData - data for image being edited */
		imageData: null,

		/** @property {Object} imageEditorInfoCheckbox - reference to the "Do not show again." checkbox for the info panel */
		imageEditorInfoCheckbox: null,

		/** @property {cnl} newImageUrl - url of edited image */
		newImageUrl: "",

		/** @property {boolean} replaced - indicates if new image replaced the old one, or was added */
		replaced: false,

		/** @property {boolean} _replaceable - flag for save and replacable images */
		_replaceable: false,

		constructor() {
			const {imageData: {showWhereUsed, url}} = this;
			this.m_urlNode = url;
			this.imageNode = this.m_cache.getNode(url);
			this._replaceable = showWhereUsed;
		},

		/**
		 * Add actions for popup view - they will replace that of the current view
		 */
		addProxyActions(defView, defActions) {
			defActions.addAction(this.getProxyAction(this._replaceable ? "SaveAsNew" : "Save", true, {
				m_bSubmit: true
			}));

			if (this._replaceable) {
				defActions.addAction(this.getProxyAction("Save_Replace", true, {
					classController: _SaveReplaceController,
					m_bSubmit: true,
					m_class: html.CSS_BUTTON_SECONDARY,
					m_tooltip: locale.resource("Save_Replace_Image")
				}));
			}
		},

		createInfoTooltip() {
			const {imageData: {dateCreated, height, imageSize, imageType, name, width}} = this;

			$("body").addClass("csi-show-image-editor");

			const label = `<div title="${name}">${locale.resource("ImageName")}: <b>${name}</b></div>` +
				`<div>${locale.resource("DateCreated")}: <b>${dateCreated}</b></div>` +
				`<div>${locale.resource("ViewPreferences_ImageSize")}: <b>${imageSize}</b></div>` +
				`<div>${locale.resource("ImageDimension")}: <b>${width} X ${height} PX</b></div>` +
				`<div>${locale.resource("ImageType")}: <b>${imageType}</b></div>`;

			new Tooltip({
				connectId: ["csi-image-editor-image-info"],
				label,
				position: ['below']
			});
		},

		/**
		 * Add additional attribute values to be submitted along with the image field
		 * @param {object} req - post request
		 */
		onUploadRequest(req) {
			const {imageData: {containerUrl, url}, m_proxy, popupView, _replaceable} = this;

			// the NewFileController by defaults sets the URL to the parent url
			req.addParameter("URL", url);

			if (_replaceable) {
				// the parameters below only apply if editing an image in ImageContainer.Images
				req.addParameter("Parent", containerUrl);

				if (m_proxy.m_action.m_id === "Save_Replace") {
					req.addParameter("Unlink", popupView.whereUsedUnlinkList);
					req.addParameter("ReplaceExisting", true);
				}
			}
		},

		/**
		 * @override
		 * Handle any reference to image not from ImageContainer.Images
		 */
		onSecondaryPublish(w) {
			const {imageData, m_response, _replaceable} = this;
			const {containerAttributeId, containerUrl, editableAttributeKey} = imageData;
			const imageNode = m_response.getNodeOfType(reflection.TYPE_IMAGE);

			if (imageNode) {
				const url = this.newImageUrl = imageNode.$URL;

				if (!_replaceable) {
					const cn = w.changeNode(containerUrl);

					if (editableAttributeKey == null) {
						cn.changeAttribute(containerAttributeId, xml.ATTR_REF, url);
					} else {
						cn.changeAttributeKeys(containerAttributeId, xml.ATTR_REFMAP, {[editableAttributeKey]: url});
					}
				}
			}
		},

		/**
		* Sets the popup window title based on the type of viewer.
		*/
		getTitle() {
			return this.imageData.name;
		},

		/**
		* Return view definition for Image Editor
		*/
		getActionView(vr) {
			var node = this.getNode();
			var defView = new View();

			defView.m_id = "LightBoxEditor";
			defView.classController = LightBoxEditor;

			return new ActionView(this, defView, node);
		},

		onCreatePopupDialogParams(dialogParams) {
			dialogParams.baseClass = `csi-lightBoxEditor${this._replaceable ? " csi-save-replace-lightBoxEditor" : ""}`;
			this.inherited(arguments);
		},

		/**
		 * Return if checkbox was checked
		 * @return {boolean}
		 */
		isChecked() {
			return this.imageEditorInfoCheckbox.checked;
		},

		/**
		 * Hides the panel informing users about possible file format conversion when saving
		 */
		hideInfoPanel() {
			$(this.popupView.imageEditorMessageNode).hide();
		},

		/**
		 * Show the lightbox background on popup open
		 */
		onLoadPopup(view) {
			this.inherited(arguments);

			$(".dijitDialogUnderlayWrapper").addClass("csi-image-editor-wrapper");
			var hideInfoMessage = storage.get(IMAGE_EDITOR_INFO_STORAGE_KEY);

			if (!hideInfoMessage) {
				//Create the checkbox, checkbox text, and dismiss button for the info panel
				var self = this;
				var checkboxDiv = $(self.popupView.imageEditorCheckbox)[0];

				this.imageEditorInfoCheckbox = new CheckBox({
					checked: false
				}).placeAt(self.popupView.imageEditorCheckbox);

				html.text(checkboxDiv, locale.resource("ImageEditorDoNotShow"));

				var button = new Button({
					label: locale.resource("Dismiss"),
					"class": 'csi-secondary-btn',
					onClick(e) {
						storage.set(IMAGE_EDITOR_INFO_STORAGE_KEY, self.isChecked());
						self.hideInfoPanel();
					}
				}).placeAt(self.popupView.imageEditorDismissButton);

				var messageText = locale.resource("ImageEditorInfoMessage");
				html.multiLineText(document.getElementById("imageEditorInfoMessage"), messageText);
			} else {
				this.hideInfoPanel();
			}

			var self = this;

			var infoIcon = html.create("span", {
				"class": "csi-image-info material-icons material-info-icon",
				id: "csi-image-editor-image-info",
				innerText: "error_outline"
			}, this._popupDialog.titleNode, "after");

			//initialize tooltip
			self.createInfoTooltip();

			$(infoIcon).mouseover(function() {
				self.createInfoTooltip();
			});

			// hide where used if only saving 
			if (!this._replaceable) {
				$(this.popupView.imageEditorControlNode).find(".csi-image-editor-where-used").hide();
			}
		},

		process() {
			const proxyAction = this.m_proxy?.m_action.m_id;

			if (proxyAction == "Save_Replace" || proxyAction == "SaveAsNew" || proxyAction == "Save") {
				this.replaced = (proxyAction !== "SaveAsNew");
				this.inherited(arguments);
			} else {
				this.postProcess();
			}
		},

		/**
		 * Cleanup styling when done
		 */
		postProcess(bStatus, bRepeat) {
			$(".dijitDialogUnderlayWrapper").removeClass("csi-image-editor-wrapper");
			$("body").removeClass("csi-show-image-editor");
			this.inherited(arguments);
		},

		/**
		 * Validate that there are snapshots to upload
		 */
		validate(ac) {
			this.actionValue = ac.widget.getEditedImage();
			return ac.widget.isImageEdited();
		}
	});
});
